<script setup>
import Form from '@/Pages/Public/MembershipApplication/Form'
import PaymentStepInfo from '@/Pages/Public/MembershipApplication/PaymentStepInfo'

import { Inertia } from '@inertiajs/inertia'

import { usePaymentsStore } from '@/Stores/payments'
const payments = usePaymentsStore()

import { useAuthStore } from '@/Stores/auth'
const auth = useAuthStore()

const props = defineProps({
	membershipApplication: {
		required: true,
	}
})

function addPaymentMethod(){
	payments.setSuccessCallback(onSuccess)
	payments.showSaveCardForm('organisation', props.membershipApplication.organisation_id, PaymentStepInfo)
	removeNavigateHandler()
}

function onSuccess(){
	payments.hideSaveCardForm()
	Inertia.visit('/membership-application/thank-you')
}

// https://inertiajs.com/events#removing-listeners
const removeNavigateHandler = Inertia.on('navigate', () => {
	addPaymentMethod()
})
</script>

<template>
	<Form
		:fields="membershipApplication"
		:membership-tiers="[]"
		:payment-frequencies="[]"
		:disabled="true"
	/>
</template>